import { FLAT_RATE_PLANS, flatRatePlanNames } from "@common/flatRateBilling";
import { SubscriptionType } from "@common/types/billing";
import { Button } from "@design-system/Button/Button";
import { useCanManageWorkspaceBilling } from "@hooks/permissions/useCanManageWorkspaceBilling";
import { useBillingStatus } from "@hooks/useBillingStatus";
import { usePlanManagement } from "@components/billing/PlanManagement/PlanManagementContext";
import { PlanManagementProvider } from "@components/billing/PlanManagement/PlanManagementProvider";

const UpgradeToBasicButton: React.FC = () => {
    const { upgrade } = usePlanManagement();

    return (
        <Button
            variant="primary"
            size="md"
            onClick={() => upgrade(FLAT_RATE_PLANS.BASIC, false)}
        >
            Upgrade to {flatRatePlanNames[FLAT_RATE_PLANS.BASIC]}
        </Button>
    );
};

export const ImporterUpgradePlanButton: React.FC = () => {
    const canManageBilling = useCanManageWorkspaceBilling();
    const { isFetched, subscriptionType } = useBillingStatus();

    if (
        !canManageBilling ||
        !isFetched ||
        subscriptionType !== SubscriptionType.FLAT_RATE
    ) {
        return null;
    }

    return (
        <PlanManagementProvider>
            <UpgradeToBasicButton />
        </PlanManagementProvider>
    );
};
